import React, { useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

//i18n
import { withTranslation } from "react-i18next";
import SidebarContent from "./SidebarContent";

import { Link } from "react-router-dom";

import logo from "../../assets/images/deal.png";
import logoLightPng from "../../assets/images/deal.png";
import logoLightSvg from "../../assets/images/deal.png";
import { useSelector, useDispatch } from "react-redux";
import { mapApiArrayData, dynamicSort } from "../../helpers/helpers";
// import { getAllRoles } from "../../store/roles/actions";
const Sidebar = (props) => {
  // const dispatch = useDispatch();

  useEffect(() => {
    // dispatch(getAllRoles());
  }, []);
  let Users = useSelector((state) => state.roles.Index ?? []);
  Users = mapApiArrayData(Users).filter(
    (user) => !["Cashier", "End User"].includes(user.label)
  );
  Users = Users.sort(dynamicSort("label"));
  return (
    <React.Fragment>
      <div className="vertical-menu">
        <div className="navbar-brand-box">
          <Link to="/" className="logo logo-dark">
            <span className="logo-sm">
              <img src={logo} alt="" height="22" />
            </span>
          </Link>

          <Link to="/" className="logo logo-light">
            <span className="logo-sm">
              <img src={logoLightSvg} alt="" height="22" />
            </span>
            <span className="logo-lg">
              <img
                src={logoLightPng}
                alt=""
                width="100%"
                minwidth="50"
                maxwidth="50"
                style={{ width: "100px", height: "90px" }}
              />
            </span>
          </Link>
        </div>
        <div data-simplebar className="h-100">
          {props.type !== "condensed" ? (
            <SidebarContent Users={Users} />
          ) : (
            <SidebarContent />
          )}
        </div>
        <div className="sidebar-background"></div>
      </div>
    </React.Fragment>
  );
};

const mapStatetoProps = (state) => {
  return {
    layout: state.Layout,
  };
};
export default connect(mapStatetoProps, {})(withTranslation()(Sidebar));
